package org.zq.astrock_ai.ui.research.gushi.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import org.zq.astrock_ai.platform.ClipboardHelper
import org.zq.astrock_ai.platform.ShareHelper
import org.zq.astrock_ai.ui.research.gushi.StockColors
import org.zq.astrock_ai.ui.research.gushi.adaptiveDialogWidth

@Composable
fun ExportTextDialog(
    title: String,
    content: String,
    onDismiss: () -> Unit,
) {
    var copied by remember { mutableStateOf(false) }
    var shared by remember { mutableStateOf(false) }
    val shape = RoundedCornerShape(14.dp)
    Dialog(onDismissRequest = onDismiss) {
        Column(
            modifier = Modifier
                .adaptiveDialogWidth(440.dp)
                .heightIn(max = 520.dp)
                .background(Color.White, shape)
                .border(BorderStroke(1.dp, StockColors.Border), shape)
                .padding(18.dp),
        ) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Text(
                    title,
                    color = StockColors.TextPrimary,
                    fontWeight = FontWeight.Bold,
                    fontSize = 17.sp,
                    modifier = Modifier.weight(1f),
                )
                Text(
                    if (shared) "已分享" else "分享",
                    color = if (shared) StockColors.DownGreen else StockColors.PrimaryBlue,
                    fontSize = 13.sp,
                    fontWeight = FontWeight.SemiBold,
                    modifier = Modifier
                        .background(Color(0xFFE8F0FE), RoundedCornerShape(12.dp))
                        .clickable {
                            shared = ShareHelper.shareText(title, content)
                            if (!shared) copied = ClipboardHelper.copyText(content)
                        }
                        .padding(horizontal = 10.dp, vertical = 5.dp),
                )
                Spacer(Modifier.width(8.dp))
                Text(
                    if (copied) "已复制" else "复制",
                    color = if (copied) StockColors.DownGreen else StockColors.PrimaryBlue,
                    fontSize = 13.sp,
                    fontWeight = FontWeight.SemiBold,
                    modifier = Modifier
                        .background(Color(0xFFE8F0FE), RoundedCornerShape(12.dp))
                        .clickable {
                            copied = ClipboardHelper.copyText(content)
                        }
                        .padding(horizontal = 10.dp, vertical = 5.dp),
                )
                Spacer(Modifier.width(8.dp))
                Text(
                    "关闭",
                    color = StockColors.TextSecondary,
                    fontSize = 13.sp,
                    modifier = Modifier
                        .clickable(onClick = onDismiss)
                        .padding(6.dp),
                )
            }
            Spacer(Modifier.height(8.dp))
            Text(
                "可分享到系统应用，或复制后粘贴到 Excel。",
                color = StockColors.TextSecondary,
                fontSize = 11.sp,
            )
            Spacer(Modifier.height(10.dp))
            Text(
                content,
                color = StockColors.TextPrimary,
                fontSize = 11.sp,
                fontFamily = FontFamily.Monospace,
                modifier = Modifier
                    .fillMaxWidth()
                    .weight(1f, fill = false)
                    .heightIn(min = 180.dp, max = 360.dp)
                    .background(Color(0xFFF8F9FB), RoundedCornerShape(8.dp))
                    .padding(10.dp)
                    .verticalScroll(rememberScrollState()),
            )
        }
    }
}
